import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { EFReplayH5 } from '@/components/UI/svg/dg200';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');
import Image from '@/components/UI/Image';

export default function ProgressH() {
    const { useLang, useState, useEffect, useRef, isMobile } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const videoRef = useRef(null);
    const video2Ref = useRef(null);
    const [showPlay, setShowPlay] = useState(!isMobile);
    const [showPlay2, setShowPlay2] = useState(!isMobile);

    let controller: any;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sec2El = document.querySelector('.dg200 .progressH .sec2') as HTMLElement;
        new ScrollMagic.Scene({
            triggerElement: '.dg200 .progressH .sec2',
            offset: (sec2El?.offsetHeight / 4) * 3,
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%',
        })
            .setClassToggle('.dg200 .progressH .sec2Box', 'enter')
            .addTo(controller);
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .progressH ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.to(target, 0.5, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.sec1 .title');
            textFadeInOut('.sec1 .desc');
            textFadeInOut('.sec1 .subs');
            textFadeInOut('.sec3 .title');
            textFadeInOut('.sec3 .desc');
            textFadeInOut('.sec4 .title');
            textFadeInOut('.sec4 .desc');
        }
    }, []);

    useEffect(() => {
        if (!isMobile) {
            new ScrollMagic.Scene({
                triggerElement: '.dg200 .progressH .bottomSec',
                offset: layoutH * 1.5,
                triggerHook: 1,
            })
                .setClassToggle('.dg200 .progressH .bottomSec .boxIn', 'enter')
                .addTo(controller);
        }
    }, []);

    useEffect(() => {
        const scene5 = new ScrollMagic.Scene({
            triggerElement: '.dg200 .progressH .bottomSec .sec3 .videoBox',
            offset: 0,
            triggerHook: 1,
        });
        scene5.on('enter', () => {
            videoRef.current?.play();
        });
        scene5.addTo(controller);
    }, []);

    useEffect(() => {
        const scene6 = new ScrollMagic.Scene({
            triggerElement: '.dg200 .progressH .bottomSec .sec4 .videoBox',
            offset: isMobile ? 0 : layoutH,
            triggerHook: 1,
        });
        scene6.on('enter', () => {
            video2Ref.current?.play();
        });
        scene6.addTo(controller);
    }, []);

    return (
        <div className={`progressH ${css.progressH} ${isMobile ? 'progressH_h5' : 'progressH_pc'}`}>
            <div className="container">
                <div className="sec1">
                    <div className="left">
                        <p className="title">{t('dg200.pregressH_sec1_title')}</p>
                        <p className="desc">{t('dg200.pregressH_sec1_desc')}</p>
                        <div className="subs">
                            <div className="subItem">
                                <p className="num"> {t('dg200.pregressH_sec1_num1')}</p>
                                <p className="text">{t('dg200.pregressH_sec1_text1')}</p>
                            </div>
                            <div className="subItem">
                                <p className="num"> {t('dg200.pregressH_sec1_num2')}</p>
                                <p className="text">{t('dg200.pregressH_sec1_text2')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="imgBox">
                            <EFPic
                                name={[`${isMobile ? 'h5/6_1.webp' : 'pc/6_1.webp'}`, `${isMobile ? 'h5/6_1.png' : 'pc/6_1.png'}`]}
                                // layout="fill"
                                className="fullImgs"
                                alt={t('dg200.pregressH_sec1_title')}
                                aria-label={t('dg200.pregressH_sec1_title')}
                            />
                        </div>
                    </div>
                </div>
                <div className="sec2">
                    <div className="sec2Box">
                        <div className="line"></div>
                        {!isMobile && (
                            <div className="top">
                                <div className="left">{t('dg200.progressH_sec2_info1')}</div>
                                <div className="right">
                                    <div className="msg">{t('dg200.progressH_sec2_info1_msg')}</div>
                                    <div className="dotLine"></div>
                                    <div className="greenBar"></div>
                                    <div className="saveBar">
                                        <div className="bg">
                                            <Image src="/media/dg200/pc/saveBar.svg" layout="fill" className="fullImgs" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {isMobile && (
                            <div className="top">
                                <div className="topIn">
                                    <div className="msg">{t('dg200.progressH_sec2_info1_msg')}</div>
                                    <div className="dotLine"></div>
                                    <div className="greenBar"></div>
                                    <div className="saveBar">
                                        <div className="bg">
                                            <Image src="/media/dg200/h5/saveBar.svg" layout="fill" className="fullImgs" />
                                        </div>
                                    </div>
                                </div>
                                <div className="botIn">{t('dg200.progressH_sec2_info1')}</div>
                            </div>
                        )}
                        {!isMobile && (
                            <div className="bottom">
                                <div className="left">{t('dg200.progressH_sec2_info2')}</div>
                                <div className="right">
                                    <div className="innerBar"></div>
                                </div>
                            </div>
                        )}
                        {isMobile && (
                            <div className="bottom">
                                <div className="topIn">
                                    <div className="innerBar"></div>
                                </div>
                                <div className="botIn">{t('dg200.progressH_sec2_info2')}</div>
                            </div>
                        )}
                    </div>
                    <p className="sup">{t('dg200.progressH_sup')}</p>
                </div>
            </div>
            <div className="bottomSec">
                <div className={`sec3Sec4Box`}>
                    <div className={`boxIn`}>
                        <div className="sec3">
                            <div className="sec3Box">
                                <div className="left">
                                    <p className="title">{t('dg200.pregressH_sec3_title')}</p>
                                    <p className="desc">{t('dg200.pregressH_sec3_desc')}</p>
                                </div>
                                <div className="right">
                                    <div className="videoBox">
                                        <EFVideo
                                            ref={videoRef}
                                            sources={[`/video/dg200/${isMobile ? '7_1_h5' : '7_1'}.webm`, `/video/dg200/${isMobile ? '7_1_h5' : '7_1'}.mp4`]}
                                            width="100%"
                                            height="100%"
                                            loop={false}
                                            onPlay={() => setShowPlay(false)}
                                            onEnded={() => setShowPlay(true)}
                                        />
                                        {showPlay && (
                                            <div className="playIcon" onClick={() => videoRef.current?.play()}>
                                                <EFReplayH5 />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`sec4`}>
                            <div className="sec4Box">
                                <div className="textBox">
                                    <p className="title">{t('dg200.pregressH_sec4_title')}</p>
                                    <p className="desc">{t('dg200.pregressH_sec4_desc')}</p>
                                    <p className="sup">{t(`dg200.pregressH_sec4_sup${isMobile ? '_h5' : ''}`)}</p>
                                </div>
                                <div className="videoBox">
                                    <EFVideo
                                        ref={video2Ref}
                                        sources={[`/video/dg200/${isMobile ? '7_2_h5' : '7_2'}.webm`, `/video/dg200/${isMobile ? '7_2_h5' : '7_2'}.mp4`]}
                                        className="sec4Video"
                                        width="100%"
                                        height="100%"
                                        loop={false}
                                        onPlay={() => setShowPlay2(false)}
                                        onEnded={() => setShowPlay2(true)}
                                    />
                                    {showPlay2 && (
                                        <div className="playIcon" onClick={() => video2Ref.current?.play()}>
                                            <EFReplayH5 />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
